<template>
    <div>
        <multiselect class="form-control" v-model="modelo.idusuario" :options="datos" track-by="id" label="nombres" :hide-selected="true" 
            :searchable="true" :close-on-select="false" :multiple="multiple" :show-labels="false" placeholder="Seleccione...">
            
            <template slot="tag" slot-scope="{ option, remove }">
                        <div>
                          <span class="custom__tag">
                            <span class="custom__remove" @click="remove(option)">❌</span>
                            <span> {{option.nombres}} </span>
                          </span>
                        </div>
                      </template>

        </multiselect>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ 
        model:Object,
        models:{type:Object,required:false},
        idsede:{type:Number,required:false},
        xdefault:{type:Array,required:false},
        multiple:{type:Boolean,required:false,default:false} 
    },
    data(){
        return{
            datos: [],
            modelo: {
                idusuario: null,
            }
        }
    },
    watch:{
        'modelo.idusuario': function(){
            if( this.models != null ){
                this.models.usuarios = this.modelo.idusuario; 
            }else{
                this.model.idusuario = this.modelo.idusuario; 
            }
        },
        'idsede': function(){
          this.getDatos();
        },
        xdefault:{
          deep: true,
          handler(){
            window.console.log( "slkdhsdkhfkjsdhfjkshdfjkhfds",this.modelo )
            this.modelo.idusuario = this.xdefault;
          }
        },
    },
    methods:{
        async getDatos() {
            if( this.idsede == null ){
                return;
            }
            var vue = this;
            var sql = gql`query{ getSede(id:${this.idsede}){usuarios_activos{usuario{datos_personales{id,nombres,pri_apellido,seg_apellido}}}} }`;
            window.console.log( sql )
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                var sed = data.data.getSede;
                var datas = [];
                if( sed.usuarios_activos == null ) return;
                sed.usuarios_activos.forEach( function(e){
                    var dp = e.usuario.datos_personales;
                    var seg = dp.seg_apellido==null?'':dp.seg_apellido;
                    var no = dp.nombres+" "+dp.pri_apellido+" "+seg;
                    datas.push({ id:dp.id,nombres:no });
                    
                });
                 vue.datos = datas;
                
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getSede' ) )
            })
        },
    },
    mounted(){
        this.getDatos();
        if( this.xdefault ){
          this.modelo.idusuario = this.xdefault;
          //window.console.log( "-------------------------------------",this.modelo );
        }
    }
}
</script>